import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { path } from '../constants';
import { useCustomToast } from '../contexts/CustomToastContext';
import CustomToast from '../components/CustomToast';
import SideBar from '../components/SideBar';
import Footer from '../components/Footer';
import Header from '../components/Navbar/Header';

export const useAuth = () => {
  const authToken = localStorage.getItem("access_token");
  return !!authToken;
};

export const PrivateRoutes: React.FC = () => {


  const token = useAuth();
  const { message } = useCustomToast();

  return token ?
    <div className="p-0 container-fluid d-flex">
      {message.text && <CustomToast />}
      <SideBar />
      <div className="sub-container full-height">
        <Header />
        <Outlet />
        <Footer />
      </div>
    </div>
    : <Navigate to={path.LOGIN} replace />;
};
export default PrivateRoutes;
